import { render, staticRenderFns } from "./cardActivityDetail.vue?vue&type=template&id=7708c938&scoped=true"
import script from "./cardActivityDetail.vue?vue&type=script&lang=js"
export * from "./cardActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./cardActivityDetail.vue?vue&type=style&index=0&id=7708c938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7708c938",
  null
  
)

export default component.exports